import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import PlanProgressDataRepository from '../../../data/repositories/PlanProgressDataRepository';
import PlanProgressRepository from '../../repositories/PlanProgressRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    const { acadPlan, prog, career } = action;
    yield put({ type: Types.GET_PLAN_PROGRESS_DETAIL_REQUEST });

    const planProgressDataRepository: PlanProgressRepository =
      new PlanProgressDataRepository();

    XCheckpointManager.registerStart('Avance de plan de estudio detalle');
    const planProgressResponse = yield call(
      planProgressDataRepository.getPlanProgressDetail,
      acadPlan,
      prog,
      career
    );
    XCheckpointManager.registerEnd('Avance de plan de estudio detalle');

    if (!planProgressResponse) {
      yield put({
        type: Types.GET_PLAN_PROGRESS_DETAIL_FAILURE,
        error: 'Ocurrió un error.'
      });
      return;
    }

    yield put({
      type: Types.GET_PLAN_PROGRESS_DETAIL_SUCCESS,
      data: planProgressResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_PLAN_PROGRESS_DETAIL_FAILURE,
      error: 'Ocurrió un error.'
    });
  }
}
